import * as React from 'react';
import Box from '@mui/material/Box';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { DefaultSelectIcon } from '../../icons/default-select-icon';
import { VIEW_MODE } from '../../consts/enums';
import SelectIconModal from './SelectIconModal';
import { SelectIconStyle } from './style';

type SelectIconProps = {
    imageUrl: string,
    onSelect: (value: string) => void,
    withArrow?: boolean,
    viewMode: ViewMode
}

// todo: add disabled prop

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function SelectIcon({
  imageUrl,
  onSelect,
  withArrow,
  viewMode,
}:SelectIconProps): JSX.Element | null {
  const [open, setOpen] = React.useState<boolean>(false);
  const [value, setValue] = React.useState<string>('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleImageSelect = (itemValue: string) => {
    onSelect(itemValue);
    handleClose();
  };

  const defineImage = () => {
    if (imageUrl) {
      return (
        <img
          src={ imageUrl }
          srcSet={ imageUrl }
          width={ 24 }
          alt="icon"
          loading="lazy"
          style={ SelectIconStyle.selectedIcon.style }
        />
      );
    }

    return <DefaultSelectIcon />;
  };

  if (viewMode === VIEW_MODE.EDITABLE) {
    return (
      <>
        <Box
          style={ SelectIconStyle.box.style }
          flexDirection="row"
          alignItems="center"
          onClick={ handleClickOpen }
        >
          {defineImage()}
          {withArrow && (
            <ArrowDropDownIcon
              style={ SelectIconStyle.icon.style }
              sx={ SelectIconStyle.icon.withArrow }
            />
          )}
        </Box>
        <SelectIconModal
          isOpen={ open }
          onClose={ handleClose }
          onImageSelect={ handleImageSelect }
          inputValue={ value }
          setInputValue={ setValue }
        />
      </>
    );
  }

  if (viewMode === VIEW_MODE.HIDDEN) {
    return null;
  }

  return (
    <img
      src={ imageUrl }
      srcSet={ imageUrl }
      width={ 24 }
      alt="icon"
      loading="lazy"
    />
  );
}

SelectIcon.defaultProps = {
  withArrow: true,
};
